export default __webpack_public_path__ + "static/media/WhyNuleep.f3b9e69b.png";